var map = {
	"./VabMenuItem.vue": "./library/components/VabMenu/components/VabMenuItem.vue",
	"./VabSubMenu.vue": "./library/components/VabMenu/components/VabSubMenu.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./library/components/VabMenu/components sync recursive \\.vue$";